import React from 'react';
import { Provider, useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';

// Redux
import { ApplicationState, store } from './store/rootStore';

// Styles
// Carolina Admin
import './assets/carolina-admin-style/base.scss';
// Styles custom
import './style/styleCustomGlobal.css';

// Component's
import { ThemeProvider as MuiV5ThemeProvider } from '@mui/material/styles';
import { ThemeProvider as MuiStylesThemeProvider } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { withErrorBoundaryApp } from './components/errorsBoundary/errorBoundaryApp';
import { useVisualIdentityReducer } from './store/visualIdentity';
import { createMuiTheme } from './style/styleMaterialUIGlobal';
import { ThemeProvider } from 'styled-components';
import { StyleStyledUIGlobal } from './style/styleStyledUIGlobal';
import { ToastContainer } from 'react-toastify';
import { HashRouter } from 'react-router-dom';
import LayoutApp from './components/layouts/layoutApp/layoutApp';
import { Routes } from './components/routes/routes';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { getLocale } from './services/utilsDate';
import { CultureEnum } from './services/enum/CultureEnum';

import { useUserLocation } from './hooks/useUserLocation';

// Utils

function App() {
  return (
    <Provider store={store}>
      <AppWithTheme />
    </Provider>
  );
}

function AppWithTheme() {
  useUserLocation();
  const { visualIdentity: { colors } } = useVisualIdentityReducer();
  const { currentUser } = useSelector((state: ApplicationState) => state.user)
  const cultureUser = currentUser?.idCulture || CultureEnum.enUS;
  const themeMUI = createMuiTheme(colors as any);

  return (
    <MuiV5ThemeProvider theme={themeMUI}>
      <MuiStylesThemeProvider theme={themeMUI}>
        <CssBaseline />
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={getLocale(cultureUser)}>
          <ThemeProvider theme={colors as any}>
            <StyleStyledUIGlobal />
            <ToastContainer autoClose={5000} hideProgressBar toastClassName="toast-with-linebreaks" />
            <HashRouter>
              <LayoutApp>
                <Routes />
              </LayoutApp>
            </HashRouter>
          </ThemeProvider>
        </LocalizationProvider>
      </MuiStylesThemeProvider>
    </MuiV5ThemeProvider>
  );
}

export default withErrorBoundaryApp(App);